import { render, staticRenderFns } from "./BidderAllOffersView.vue?vue&type=template&id=5d4c76d4&scoped=true&"
import script from "./BidderAllOffersView.vue?vue&type=script&lang=js&"
export * from "./BidderAllOffersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c76d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
